interface DataType {
    Options?: Array<{ Label: string }>;
    Size?: {
        Title: string;
    };
}

export const getVariantDescription = (data: DataType): string => {
    const optionsText = data.Options?.map((opt) => opt.Label).join(', ');
    const sizeText = data.Size && data.Size.Title;

    return optionsText && sizeText
        ? `${optionsText}, ${sizeText}`
        : optionsText || sizeText || '';
};
